// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3oZVy","selected":"Chip_selected__3LWk3"};